/**
 * A value one click from the clipboard.
 *
 * Every id, key and DNS record in this product is something someone has to
 * paste somewhere else. The button stays in the DOM rather than being hidden,
 * so it is reachable by keyboard; it only fades in on hover.
 */

import { Icon } from "./Sprites";
import { useCopy } from "../hooks";

interface CopyValueProps {
  value: string;
  /** What is shown, when it differs from what is copied. */
  display?: string;
  label?: string;
  className?: string;
}

export function CopyValue({ value, display, label, className }: CopyValueProps) {
  const { copied, copy } = useCopy();
  const isCopied = copied === value;

  return (
    <span className={className ? `oc-copy ${className}` : "oc-copy"}>
      <span className="oc-copy__value">{display ?? value}</span>
      <button
        type="button"
        className="oc-copy__btn"
        data-copied={isCopied ? "true" : undefined}
        aria-label={isCopied ? "Copied" : (label ?? `Copy ${value}`)}
        onClick={() => copy(value)}
      >
        <Icon name={isCopied ? "check" : "copy"} size={14} />
      </button>
    </span>
  );
}
